const GraphPrefix = require('./GraphPrefix');
const { query } = require('@simpleview/sv-graphql-client');

class NotificationsPrefix extends GraphPrefix {
	constructor({ graphUrl, graphServer }) {
		super({ name: 'notifications', graphUrl, graphServer })
	}

	async remove({ fields, context, filter, headers }) {
		context = context || this._graphServer.context;

		const variables = {
			filter
		};

		const result = await query({
			query : `
				mutation( $filter: bbs_notifications_remove_filter! ){
					bbs( input: {bbs_credentials} ) {
						notifications_remove(
							filter: $filter
						) {
							${fields}
						}
					}
				}
			`,
			variables,
			url : this._graphUrl,
			token : context.token,
			headers
		});
		return result.bbs.notifications_remove;
	}

	async upsert({ fields, context, input, headers }) {
		context = context || this._graphServer.context;

		const variables = {
			input
		};

		const result = await query({
			query : `
				mutation( $input: bbs_notifications_upsert_input! ){
					bbs( input: {bbs_credentials} ) {
						notifications_upsert(
							input: $input
						) {
							${fields}
						}
					}
				}
			`,
			variables,
			url : this._graphUrl,
			token : context.token,
			headers
		});
		return result.bbs.notifications_upsert;
	}
}

module.exports = NotificationsPrefix;